module.exports = __webpack_public_path__ + "media/images/icons/flags/LS-64e5565f34b10b6bce1d68e739d95109.svg";